import React from "react";

import ReportsLinks from "./components/ReportsLinks";
import DateBoxes from "../ClientDiary/Index/components/Date-boxes/DateBoxes";

const ClientReportsPage: React.FC = () => {
  return <DateBoxes LinksComponent={<ReportsLinks />} />;
};

export default ClientReportsPage;
